<div style="display: flex; align-items: center; justify-content: space-between;">
    <h4 style="margin: 0; flex: 1; text-align: center;">PROBLEM  RESOLUTION</h4>
    <button *ngIf="action == 'edit'" mat-icon-button color="primary" (click)="editData()">
        <mat-icon class="mat-18">edit</mat-icon>
    </button>
</div>
  
<div class="styled-form">
<form style="padding: 15px;" [formGroup]="formGroup" (ngSubmit)="submit(formGroup)">
    <mat-dialog-content>
        <div class="row col-md-12">
            <div class="col-md-4">
            <mat-form-field>
                <mat-label>Site Name</mat-label>
                <mat-select formControlName="sitename" required>
                    <mat-option  *ngFor="let site of siteName" [value]="site.sitename" (click)="getTransformerID(site)">{{site.sitename}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-md-4">
            <mat-form-field>
                <mat-label>Transformer ID</mat-label>
                <input type="text" matInput placeholder="Transformer ID" formControlName="transformerid" readonly>
            </mat-form-field>
        </div>
        <div class="col-md-4">
            <mat-form-field>
                <mat-label>Select Maintenance Planning</mat-label>
                <mat-select formControlName="maintainance" required>
                    <mat-option  *ngFor="let site of selectedMaintainance" [value]="site.selectedOptions" >{{site.selectedOptions}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="row" style="margin-top: 5%; ">
        <div class="col-md-4">
            <mat-form-field  >
                <mat-label>Maintainance Resolution Date</mat-label>
                <input type="datetime" matInput [matDatepicker]="picker" formControlName="date">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>

            </mat-form-field>
        </div>
        <div class="col-md-4">
            <mat-form-field>
                <mat-label>Resolution Method</mat-label>
                <input type="text" matInput  formControlName="resolutionmethod" placeholder="e.g., Part Replacement, Re-calibration">
            </mat-form-field>
            
        </div>
        <div class="col-md-4">
            <mat-form-field>
                <mat-label>Parts Replaced/Fixed</mat-label>
                <input type="text" matInput placeholder="List of parts replaced or fixed" formControlName="partreplaced" >
            </mat-form-field>
            
        </div>
    </div>
    <div class="row" style="margin-top: 5%;">
        <div class="col-md-4">
                <mat-form-field>
                    <mat-label>Engineer Name</mat-label>
                    <input type="text" matInput placeholder="Engineer Name" formControlName="engineername" >
                </mat-form-field>
                
        </div>
        <div class="col-md-4">
            <mat-form-field>
                <mat-label>Issue Root Cause</mat-label>
                <input type="text" matInput placeholder="Enter Root Cause" formControlName="rootcause" >
            </mat-form-field>
            
    </div>  
    <div class="col-md-4">
        <mat-form-field>
            <mat-label>Transformer Status After</mat-label>
            <input type="text" matInput placeholder="Current status of transformer" formControlName="transformerstatus" >
        </mat-form-field>
       
</div>  
     </div> 
     <div class="row" style="margin-top: 5%;">
        <div class="col-md-12">
            <mat-form-field appearance="fill">
                <mat-label>Comment</mat-label>
                <textarea matInput formControlName="notes" rows="4" placeholder="Enter your comments here..."></textarea>
            </mat-form-field>
        </div>
    </div>  
    </mat-dialog-content>
    <button style="left:45%" [disabled]="!formGroup.valid"  mat-raised-button color="primary" type="submit">SAVE</button>
</form>
</div>